
import { CommonUtilities } from '../../commonUtils';

export default class LabelServices {

    //https://qa.onkorrect.com/Api/contracts/freeText/?formArea=ShortLabelCode
    static freeText(data: any) {
        var url = 'contracts/freeText/?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static freeTextSave(data: any) {
        var url = 'contracts/freeText';
        return CommonUtilities.postData(url, data);
    }

    static freeTextDelete(data: any) {
        var url = 'contracts/freeText/' + data;
        return CommonUtilities.deleteData(url);
    }

    static kontactImprintTypeSave(data: any) {
        var url = 'Contract/kontactImprintType/save';
        return CommonUtilities.postData(url, data);
    }

    static kontactTaxFormInformationSave(data: any) {
        var url = 'Contract/kontactTaxFormInformation/save';
        return CommonUtilities.postData(url, data);
    }

    static kontactCompanyInfoSave(data: any) {
        var url = 'Contract/kontactCompanyInfo/save';
        return CommonUtilities.postData(url, data);
    }

    static kontactAccountingDetailsSave(data: any) {
        var url = 'Contract/kontactAccountingDetails/save';
        return CommonUtilities.postData(url, data);
    }


    static kontactCompanyInfoDelete(data: any) {
        var url = 'Contract/kontactCompanyInfo/delete/' + data;
        return CommonUtilities.deleteData(url);
    }

    static kontactImprintTypeDelete(data: any) {
        var url = 'Contract/kontactImprintType/delete/' + data;
        return CommonUtilities.deleteData(url);
    }
}
